// Builds a link that carries the locked single-page flag forward, so the locked
// perimeter (no back/close, no escape to the main app shell) survives a hop to
// another page. Only this perimeter flag is carried — flow-internal params
// (step / reason / sentiment) deliberately do NOT leak across pages. The `?`/`&`
// separator is handled so it composes with paths that already carry a query.
//
// Used when arriving via /autologin without a parent surface to return to
// (embedded email link, mobile webview handoff), where every nav-away
// affordance is hidden and the user closes the webview to get back to the app.
export function withSinglePage(path: string, singlePage: boolean): string {
  if (!singlePage) return path
  const separator = path.includes('?') ? '&' : '?'
  return `${path}${separator}singlePage=true`
}
